/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_Close_MenuInputs */

const en_directory_sidebar_close_menu = /** @type {(inputs: Directory_Sidebar_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const zh_directory_sidebar_close_menu = /** @type {(inputs: Directory_Sidebar_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭菜单`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Directory_Sidebar_Close_MenuInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_close_menu = /** @type {((inputs?: Directory_Sidebar_Close_MenuInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_Close_MenuInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_close_menu(inputs)
	return zh_directory_sidebar_close_menu(inputs)
});
export { directory_sidebar_close_menu as "directory.sidebar.close_menu" }